const trustItems = [
  {
    icon: 'ri-star-fill',
    value: '5.0',
    title: '5-Star Rated',
    subtitle: 'Google & Yelp Reviews',
    color: 'text-parkside-amber',
  },
  {
    icon: 'ri-map-pin-2-fill',
    value: '4',
    title: 'Cities Served',
    subtitle: 'Tampa Bay Area & Beyond',
    color: 'text-parkside-green',
  },
  {
    icon: 'ri-award-fill',
    value: 'ICPI',
    title: 'Certified Installer',
    subtitle: 'Expert Hardscape Specialists',
    color: 'text-parkside-amber',
  },
  {
    icon: 'ri-shield-check-fill',
    value: '✓',
    title: 'Licensed & Insured',
    subtitle: 'Bonded & Fully Covered',
    color: 'text-parkside-green',
  },
  {
    icon: 'ri-tools-fill',
    value: '500+',
    title: 'Projects Done',
    subtitle: 'Residential & Commercial',
    color: 'text-parkside-amber',
  },
];

export default function TrustBar() {
  return (
    <section className="bg-white border-b border-stone-100">
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex flex-wrap items-center justify-between gap-4">
          {trustItems.map((item, idx) => (
            <div key={item.title} className={`flex items-center gap-3 ${idx === trustItems.length - 1 ? '' : 'pr-4 md:border-r border-stone-150'}`}>
              <div className={`w-9 h-9 flex items-center justify-center bg-parkside-cream rounded-lg flex-shrink-0`}>
                <i className={`${item.icon} ${item.color} text-lg`} />
              </div>
              <div>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-parkside-dark font-bold text-sm leading-none">{item.title}</span>
                </div>
                <p className="text-parkside-stone text-xs mt-0.5 leading-none">{item.subtitle}</p>
              </div>
            </div>
          ))}
          {/* Platform logos */}
          <div className="flex items-center gap-4 pl-4 border-l border-stone-150">
            <div className="flex items-center gap-1.5">
              <span className="w-5 h-5 inline-flex items-center justify-center">
                <i className="ri-google-fill text-[#4285F4] text-lg" />
              </span>
              <div>
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map((s) => (
                    <span key={s} className="w-2.5 h-2.5 inline-flex items-center justify-center">
                      <i className="ri-star-fill text-parkside-amber text-[10px]" />
                    </span>
                  ))}
                </div>
                <p className="text-parkside-stone text-[10px]">Google Reviews</p>
              </div>
            </div>
            <div className="flex items-center gap-1.5">
              <span className="w-5 h-5 inline-flex items-center justify-center">
                <i className="ri-yelp-fill text-[#D32323] text-lg" />
              </span>
              <div>
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map((s) => (
                    <span key={s} className="w-2.5 h-2.5 inline-flex items-center justify-center">
                      <i className="ri-star-fill text-parkside-amber text-[10px]" />
                    </span>
                  ))}
                </div>
                <p className="text-parkside-stone text-[10px]">Yelp Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
